import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.InsuranceDisplayName,
  LocationVarKey.LeaseInsurance1,
  LocationVarKey.LeaseInsurance2,
  LocationVarKey.LeaseInsurance3,
  {
    key: LocationVarKey.AfterNavigateInsurance,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasInsuranceWebsiteURL, "1")
  },
  {
    key: LocationVarKey.AfterNavigateInsurance1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasInsuranceWebsiteURL, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateInsurance, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateInsurance2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasInsuranceWebsiteURL, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateInsurance, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Insurance
      </PageHeader>

      <InputRow {...page} keyName={LocationVarKey.InsuranceDisplayName} label="What do you call your insurance?" />
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.LeaseInsurance1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.LeaseInsurance2} />
      <TextAreaRow {...page} marginTop label=" Message 3" keyName={LocationVarKey.LeaseInsurance3} />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasInsuranceWebsiteURL, "1")}>
        <SwitchRow {...page} keyName={LocationVarKey.AfterNavigateInsurance} label="Ask if they want to be navigated to your Insurance Info URL" />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateInsurance, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader {...page}> After Navigate</SectionHeader>
          <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AfterNavigateInsurance1} />
          <TextAreaRow
            {...page}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateInsurance2}
            enableSwitchVar={LocationVarKey.AfterNavigateInsurance2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
